module.exports = __webpack_public_path__ + "static/media/93d3e31639a4d07613de9dccdc8bd5e8.f6138f0d.png";